import { adminProjectsService } from '@/services/admin/admin-projects-service';
import { liftPlanService } from '@/services/lift-plan/lift-plan-service';
import { useMutation } from '@tanstack/vue-query';

export const useOverviewMutation = (projectId: string) => {
  return useMutation({
    mutationKey: ['overview'],
    mutationFn: async () => {
      await adminProjectsService.syncProject(projectId);
      await liftPlanService.sync(projectId);
    },
  });
};
